import { apiService } from "../api.service";

/**
 * Upload file to backed and return url
 * @param file - File
 * @return - FileUploadResponse || ErrorResponse
 */
export const fileUpload = async file => {
  const payload = new FormData();
  payload.append("file", file);
  const response = await apiService.post("/file-management/upload", payload);
  if (response.hasError) {
    return response;
  }
  return { url: response.data.url };
};
